export enum ProviderType {
    docebo = "docebo",
    fileUploader = "fileUploader",
    googleDrive = "googleDrive"
}
